<i18n>
{
  "en": {
  },
  "es": {
  }
}
</i18n>
<template>
  <router-view />
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class LinkTree extends Vue {
}
</script>
